/* eslint-disable promise/catch-or-return,promise/prefer-await-to-then */
import AuthenticatedController from '@mm/state/controllers/AuthenticatedController';
import * as APIRoutes from '@mm/api-routes';
import { ErrorReportingUtils } from '@mm/plugins';
import { trackWebsiteGAEvent } from '../common/helpers/plugins/website-google-analytics';
import { GA_EVENTS } from '../common/helpers/plugins/constants';

type MarketingTypeResponse = {
  agency: true;
  company: true;
};

class MarketingService {
  static getIsQualified(): Promise<MarketingTypeResponse> {
    return AuthenticatedController.get(APIRoutes.MARKETING_ANALYTICS);
  }
}

export const MarketingAnalytics = {
  getIsQualified: async () => {
    try {
      return MarketingService.getIsQualified();
    } catch (error) {
      ErrorReportingUtils.reportError(
        `Marketing Analytics: couldn't fetch qualified props`,
        {
          extraData: { error },
        },
      );
    }
  },
};

export const trackSignUpEventGA = () => {
  trackWebsiteGAEvent(GA_EVENTS.signUp.name, {
    category: GA_EVENTS.signUp.category,
  });

  MarketingAnalytics.getIsQualified().then(qualified => {
    if (qualified?.company) {
      trackWebsiteGAEvent(GA_EVENTS.signUpQualifiedCompany.name, {
        category: GA_EVENTS.signUpQualifiedCompany.category,
      });
    }

    if (qualified?.agency) {
      trackWebsiteGAEvent(GA_EVENTS.signUpQualifiedAgency.name, {
        category: GA_EVENTS.signUpQualifiedAgency.category,
      });
    }

    return qualified;
  });
};

export const trackUpgradeEventGA = () => {
  trackWebsiteGAEvent(GA_EVENTS.planUpgrade.name, {
    category: GA_EVENTS.planUpgrade.category,
  });

  MarketingAnalytics.getIsQualified().then(qualified => {
    if (qualified?.company) {
      trackWebsiteGAEvent(GA_EVENTS.planUpgradeQualifiedCompany.name, {
        category: GA_EVENTS.planUpgradeQualifiedCompany.category,
      });
    }

    if (qualified?.agency) {
      trackWebsiteGAEvent(GA_EVENTS.planUpgradeQualifiedAgency.name, {
        category: GA_EVENTS.planUpgradeQualifiedAgency.category,
      });
    }

    return qualified;
  });
};
